import React, { FC, useState } from 'react';
import './ResultFilter.css';
import { ActionStatusHelper, AppEnum, DOMAIN_TYPES, ExportButton, FaCalendarAlt, FaFilePdf, FaToggleOff, FaToggleOn, FaUser } from '@/Shared';
import { AccessRightModel } from '@/Domains';

export interface ResultFilterCrtieria {
	isCustomDate: boolean;
	year: number;
	fromDate?: string;
	toDate?: string;
	userId?: number;
}

interface ResultFilterProps {
	onFilterChange: (partial: Partial<ResultFilterCrtieria>) => void,
	filter: ResultFilterCrtieria,
	userOptions: AppEnum[],
	accessRight: AccessRightModel
}

const ResultFilter: FC<ResultFilterProps> = ({ onFilterChange, userOptions, filter, accessRight }) => {

	const [confirmModalVisible, setConfirmModalVisible] = useState<boolean>(false);

	const handleConfirmExport = () => {
		setConfirmModalVisible(false);
		//handleExcelExport();
	}
	return (
		<div className="ResultFilter" data-testid="ResultFilter">
			<div className="ResultFilter-container">
				<h3 className='ResultFilter_title'>Filtrer les données</h3>
				<label className="data-field-label date-customized-label flex-row">
					<div className='field-text'>Personaliser periodes</div>
					<div className='field-icon' onClick={() => onFilterChange({ isCustomDate: !filter.isCustomDate })}>
						{filter.isCustomDate ? <FaToggleOn /> : <FaToggleOff />}
					</div>
				</label>
				{filter.isCustomDate ? <>
					<label className="data-field-label">
						Début
						<div className="form-group">
							<div className='Field-wrapper'>
								<div className='field-icon'><FaCalendarAlt /></div>
								<input
									type="date"
									value={filter.fromDate}
									onChange={(e) => onFilterChange({ fromDate: e.target.value })}
									className="input-field"
									name="fromDate"
								/>
							</div>
						</div>
					</label>
					<label className="data-field-label">
						Fin
						<div className="form-group">
							<div className='Field-wrapper'>
								<div className='field-icon'><FaCalendarAlt /></div>
								<input
									type="date"
									value={filter.toDate}
									onChange={(e) => onFilterChange({ toDate: e.target.value })}
									className="input-field"
									name="toDate"
								/>
							</div>
						</div>
					</label>
				</>
					:

					<label className="data-field-label">
						Année civile
						<div className="form-group">
							<div className='Field-wrapper'>
								<div className='field-icon'><FaCalendarAlt /></div>
								<input
									type="number"
									value={filter.year}
									onChange={(e) => onFilterChange({ year: parseInt(e.target.value, 10) })}
									className="input-field"
									name="year"
								/>
							</div>
						</div>
					</label>
				}

				<label className="data-field-label">
					Agent
					<div className="form-group">
						<div className='Field-wrapper'>
							<div className='field-icon'><FaUser /></div>
							<select
								value={filter.userId || ''}
								onChange={(e) =>
									onFilterChange({ userId: e.target.value ? parseInt(e.target.value, 10) : undefined })
								}
								className="select-field"
							>
								<option value="">Tous</option>
								{userOptions.map(option => (
									<option key={option.key} value={option.value}>{option.label}</option>
								))}
							</select>
						</div>
					</div>
				</label>
			</div>
			{
				accessRight.canExport(DOMAIN_TYPES.Result) &&
				<div className='DataTable-filter__buttons flex-row'>
					<ExportButton
						onClick={() => setConfirmModalVisible(true)}
						isLoading={ActionStatusHelper.isLoading('idle')}
						icon={<FaFilePdf />}
						count="rapport"
					/>
				</div>
			}
		</div>
	);
}

export default ResultFilter;
